import { render, staticRenderFns } from "./ExistingWillChangesChildrenYN.vue?vue&type=template&id=522e3fc4"
import script from "./ExistingWillChangesChildrenYN.vue?vue&type=script&lang=js"
export * from "./ExistingWillChangesChildrenYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports